import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { NpsTestIds } from '../../../utils/testIds/Nps.testIds';
import { useTranslation } from '../../translation/TranslationContext';
import useNpsScoreForm from '../hooks/useNpsScoreForm';
import NpsSlider from './NpsSlider';

const NpsScoreForm = () => {
  const { translate } = useTranslation();
  const { control, isSubmitting, handleValidSubmit, handleAnswerLater } = useNpsScoreForm();

  return (
    <Box sx={{ width: 360, maxWidth: '100%' }}>
      <form onSubmit={handleValidSubmit}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
            {translate(LangEnum.NPS_SCORE_TEXT)}
          </Typography>
        </Box>

        <Box sx={{ px: 1, pb: 2 }}>
          <NpsSlider control={control} name="score" />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            disabled={isSubmitting}
            testId={NpsTestIds.SEND_LATER_BUTTON}
            onClick={handleAnswerLater}
          >
            {translate(LangEnum.GLOBAL_SEND_REPLY_LATER)}
          </Button>
          <Button variant="contained" color="primary" size="medium" type="submit">
            {translate(LangEnum.GLOBAL_ANSWER_BUTTON_LABEL)}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NpsScoreForm;
